import React, { useState, useEffect } from "react";

import { Redirect } from "react-router-dom";

import {
  makeStyles,
  Grid,
  Container,
  TextField,
  InputAdornment,
  Paper,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
import { searchCoin } from "../apiFunctions";
import WithdrawListItem from "./WithdrawListItem";

import "./Withdraw.scss";
import {
  getPartnerShare,
  getPartnerWallet,
  getTotalPartners,
} from "./WithdrawFunctions";
import PartnersShare from "./PartnersShare";

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    borderRadius: theme.spacing(2),
    width: "100%",
    height: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperContainerItems: {
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    border: "1px solid #00000020",
    width: "100%",
  },
  ul: {
    listStyle: "none",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    padding: "2px",
    margin: "0",
    maxWidth: "min-content",
  },
  li: {
    cursor: "pointer",
    display: "flex",
    flexFlow: "row nowrap",
    borderRadius: "14px",
    outline: "none",
    textDecoration: "none",
    fontSize: ".8rem",
    fontWeight: "500",
    padding: "9px 13px",
    wordBreak: "break-word",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "&.active": {
      backgroundColor: theme.palette.background.default,
    },
  },
  customInput: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: "20px",
  },
  searchIcon: {
    color: theme.palette.grey[400],
  },
  formControl: {
    marginRight: theme.spacing(1),
    minWidth: 120,
  },
  pagination: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
}));

function Withdraw({ network }) {
  const classes = useStyles();
  const [lpTokens, setLpTokens] = useState([]);
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [lastPage, setLastPage] = useState(1);
  const [pagination, setPagination] = useState({
    page: 1,
    startIndex: 0,
    endIndex: 10,
  });

  const changePage = (event, value) => {
    let pagination_data = { ...pagination };

    pagination_data.page = value;
    pagination_data.startIndex = (value - 1) * 10;
    pagination_data.endIndex = (value - 1) * 10 + 10;

    setPagination(pagination_data);
  };

  const filteredTokens = () => {
    var items = lpTokens,
      token = search;

    if (!token) {
      return items;
    }

    token = token.trim().toLowerCase();

    items = items.filter((item) => {
      if (item.type === "token") {
        if (
          item.symbol.toLowerCase().indexOf(token) !== -1 ||
          item.name.toLowerCase().indexOf(token) !== -1
        ) {
          return item;
        }
      } else if (
        item.lptokens.token0.symbol.toLowerCase().indexOf(token) !== -1 ||
        item.lptokens.token0.name.toLowerCase().indexOf(token) !== -1 ||
        item.lptokens.token1.symbol.toLowerCase().indexOf(token) !== -1 ||
        item.lptokens.token1.name.toLowerCase().indexOf(token) !== -1
      ) {
        return item;
      }
    });

    // Return an array with the filtered data
    return items;
  };

  /**
   * Get Partners Share
   */
  const get_partners_share = async () => {
    let total_partners = await getTotalPartners(
      network.withdraw,
      network.signer
    );

    if (total_partners) {
      let partners_array = [];

      for (let i = 0; i < total_partners; i++) {
        const index = i;
        await getPartnerWallet(network.withdraw, network.signer, index).then(
          async (wallet) => {
            await getPartnerShare(
              network.withdraw,
              network.signer,
              wallet
            ).then((share) => {
              partners_array.push({
                wallet,
                share,
              });
            });
          }
        );
      }

      setPartners(partners_array);
    }
  };

  const get_lp_tokens = async () => {
    // start loading
    setLoading(true);

    // set variable
    let params = new URLSearchParams();
    params.set("page", 1);
    params.set("chainId", network.chainID);
    params.set("type", "lptoken");

    await searchCoin(params).then((res) => {
      if (res) {
        setLpTokens(res);
        setLastPage(Math.ceil(res.length / 10));
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    const withdrawTimeout = setTimeout(() => {
      if (network.withdraw) {
        get_partners_share();
        get_lp_tokens();
      }
    }, 1000);
    return () => clearTimeout(withdrawTimeout);
  }, []);
  return (
    <>
      {network.chainID != 56 ? (
        <div id="withdraw">
          <Container maxWidth="xl">
            {!!partners.length && <PartnersShare partners={partners} />}
            <Grid container className="mb-4" spacing={2}>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className="d-flex align-items-center"
              >
                <TextField
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  variant="outlined"
                  placeholder="Search..."
                  fullWidth
                  className="custom-search"
                  classes={{ root: classes.customInput }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className={classes.searchIcon} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>

            {(!filteredTokens().length || loading) && (
              <Grid container>
                <Paper elevation={0} className={classes.paperContainer}>
                  {loading ? "Loading..." : "No Token To Show"}
                </Paper>
              </Grid>
            )}

            {!!filteredTokens().length && !loading && (
              <Grid container>
                <Paper elevation={0} className={classes.paperContainerItems}>
                  <table className="w-100 withdraw-list">
                    <tbody>
                      {filteredTokens()
                        .slice(pagination.startIndex, pagination.endIndex)
                        .map((item, index) => (
                          <WithdrawListItem
                            key={`${item.symbol}_${index}_${item.address}`}
                            item={item}
                            network={network}
                          />
                        ))}
                    </tbody>
                  </table>

                  {lastPage > 1 && (
                    <Pagination
                      classes={{ root: classes.pagination }}
                      count={lastPage}
                      page={pagination.page}
                      onChange={changePage}
                    />
                  )}
                </Paper>
              </Grid>
            )}
          </Container>
        </div>
      ) : (
        <Redirect to="/invest" />
      )}
    </>
  );
}

export default Withdraw;
